import { hasWork } from '@/lib/navigation';
export const canUseArea = (user, area) => !user?.areas || user.areas.includes(area);
export function berlinDay(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
  const get = type => parts.find(p => p.type === type).value;
  return `${get('year')}-${get('month')}-${get('day')}`;
}
const enc = encodeURIComponent;
export function buildFocusTasks({ callbacks = [], followups = [], appointments = [], user, today = berlinDay() }) {
  const tasks = [];
  if (hasWork(user)) {
    for (const f of followups) {
      if (f.assigned_user_id !== user.id || f.status !== 'open' || (f.due_date && f.due_date > today)) continue;
      tasks.push({ id: `followup:${f.id}`, kind: 'Wiedervorlage', title: f.customer?.company_name || 'Kontakt nachfassen', note: f.note || 'Den nächsten Schritt mit deinem Kontakt klären.', date: f.due_date, time: f.due_time, to: `/m/followups?filter=today${f.type === 'phone_appointment' ? '&tab=termine' : ''}&open=${enc(f.id)}`, action: 'Wiedervorlage öffnen' });
    }
  }
  if (canUseArea(user,'cold_call')) {
    for (const c of callbacks) {
      tasks.push({ id: `callback:${c.lead_id}`, kind: 'Rückruf', title: c.company_name || 'Kontakt zurückrufen', note: 'Rückruf angefordert. Ergebnis im Telefonmodus erfassen.', area: 'cold_call', to: `/m/call?open=${enc(c.id)}&lead=${enc(c.lead_id)}`, action: 'Rückruf öffnen' });
    }
  }
  for (const a of appointments) {
    if (a.owner_user_id !== user.id || a.status !== 'geplant' || a.start_date !== today) continue;
    tasks.push({ id: `appointment:${a.id}`, kind: 'Termin', title: a.title || a.customer?.company_name || 'Geplanter Termin', note: a.location || 'Details und Vorbereitung im Kalender öffnen.', date: a.start_date, time: a.all_day ? null : a.start_time, to: `/m/appointments?open=${enc(a.id)}`, action: 'Termin öffnen' });
  }
  return [...new Map(tasks.map(t => [t.id, t])).values()].sort((a,b) => `${a.date || '9999'}T${a.time || '00:00'}`.localeCompare(`${b.date || '9999'}T${b.time || '00:00'}`) || a.id.localeCompare(b.id));
}
